import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {LocalStorageService} from 'ngx-webstorage';

@Component({
  selector: 'app-remove-cart-item',
  templateUrl: 'remove.component.html',
  styleUrls: ['../my-cart/my-cart.component.scss'],
})
export class RemoveCartItemComponent implements OnInit {

  dateFromRemoveItem: any;

  ngOnInit() {
    if (this.localSt.retrieve('dateFromRemoveItem')) {
      this.dateFromRemoveItem = this.localSt.retrieve('dateFromRemoveItem');
    }
  }

  constructor(private activeModal: NgbActiveModal,
              private localSt: LocalStorageService) {
  }

  closeModal(status) {
    this.localSt.clear('dateFromRemoveItem');
    this.activeModal.close(status);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/remove-cart-item/remove.component.ts